// components/Navigation.jsx
import React from 'react';
import '../../styles/Navigation.css';

export const Navigation = ({ activeTab, tabs, onTabChange, portfolioId, onPortfolioIdChange }) => {
  return (
    <nav className="sidebar">
      <div className="sidebar-header">
        <div className="logo">
          <span className="logo-icon">🛡️</span>
          <h2>Risk Manager</h2>
        </div>
        <p className="logo-subtitle">API Dashboard</p>
      </div>

      <div className="portfolio-info">
        <div className="portfolio-id">
          <span className="label">Portfolio ID:</span>
          <span className="value">{portfolioId}</span>
        </div>
        <div className="portfolio-status">
          <span className="status-dot active"></span>
          <span>Connected</span>
        </div>
      </div>

      <div className="sidebar-menu">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`menu-item ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => onTabChange(tab.id)}
          >
            <span className="menu-icon">{tab.icon}</span>
            <span className="menu-label">{tab.label}</span>
          </button>
        ))}
      </div>

      <div className="sidebar-footer">
        <div className="api-version">
          <span>API v1.0</span>
          <span className="version-badge">Production</span>
        </div>
        <div className="help-link">
          <a href="#docs">📚 Documentation</a>
        </div>
      </div>
    </nav>
  );
};